var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.5586 0H4.42969C1.98047 0 0 1.93359 0 4.32422V55.6641C0 58.0547 1.98047 60 4.42969 60H55.5586C58.0078 60 60 58.0547 60 55.6758V4.32422C60 1.93359 58.0078 0 55.5586 0ZM17.8008 51.1289H8.89453V22.4883H17.8008V51.1289ZM13.3477 18.5859C10.4883 18.5859 8.17969 16.2773 8.17969 13.4297C8.17969 10.582 10.4883 8.27344 13.3477 8.27344C16.1953 8.27344 18.5039 10.582 18.5039 13.4297C18.5039 16.2656 16.1953 18.5859 13.3477 18.5859ZM51.1289 51.1289H42.2344V37.207C42.2344 33.8906 42.1758 29.6133 37.6055 29.6133C32.9766 29.6133 32.2734 33.2344 32.2734 36.9727V51.1289H23.3906V22.4883H31.9219V26.4023H32.0391C33.2227 24.1523 36.1289 21.7734 40.4531 21.7734C49.4648 21.7734 51.1289 27.7031 51.1289 35.4141V51.1289Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.62c644a2ac41fa188da0494c4466bd70.svg";
export { ForwardRef as ReactComponent };